import { Axios } from '../axios'

const getAnnouncementCount = async () => {
  const { data } = await Axios.get(`/mobile/announcements/unread-count`)
  return data?.data
}

const getAllAnnouncements = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''

  const { data } = await Axios.get(
    `/mobile/announcements?limit=${payload.limit}&page=${payload.page}${search}`
  )
  return data?.data
}

const getUnreadAnnouncements = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''

  const { data } = await Axios.get(
    `/mobile/announcements/unread-announcements?limit=${payload.limit}&page=${payload.page}${search}`
  )
  return data?.data
}
const getSingleAnnouncement = async (payload) => {
  const { data } = await Axios.get('/mobile/announcements/show/' + payload)
  return data?.data
}

const addAnnouncementComment = async (payload) => {
  const { data } = await Axios.post(
    `/mobile/announcements/${payload.id}/comment`,
    payload.data
  )
  return data
}

const addAnnouncementReaction = async (payload) => {
  const { data } = await Axios.post(
    `/mobile/announcements/${payload.id}/react`,
    payload.data
  )
  return data
}
const openAnnouncement = async (payload) => {
  const { data } = await Axios.post(`/mobile/announcements/${payload.id}/read`)
  return data
}

export const announcements = {
  getAnnouncementCount,
  getAllAnnouncements,
  getUnreadAnnouncements,
  getSingleAnnouncement,
  addAnnouncementComment,
  addAnnouncementReaction,
  openAnnouncement,
}
